import {
  differenceInMinutes as dateFnsDifferenceInMinutes,
  parseISO,
} from 'date-fns';

type DateArgumentType = string | number | Date;

const parseDate = (date: DateArgumentType): Date | number => {
  return typeof date === 'string' ? parseISO(date) : date;
};

/**
 * Takes a timestamp, number or date string in ISO format
 * @param dateLeft
 * @param dateRight
 * @returns number
 * @example
 * ```
 * differenceInMinutes(
 *    '2021-11-11T23:00:00.000Z',
 *    '2021-11-11T22:00:00.000Z'
 * }) //=> 60
 * differenceInMinutes({
 *    new Date(2021, 9, 9, 22, 35)
 *    new Date(2021, 9, 9, 22, 15)
 * }) //=> 20
 * ```
 */
export const differenceInMinutes = (
  dateLeft: DateArgumentType,
  dateRight: DateArgumentType,
) => {
  return dateFnsDifferenceInMinutes(parseDate(dateLeft), parseDate(dateRight));
};
